var exports = {
  "Qq": "x1cb7f6e3--1ae6ca--text",
  "DD": "x1cb7f6e3--1ae6ca--title",
};

module.exports = exports;
